exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".alp-card{box-shadow:0 2px 4px 0 rgba(0,0,0,.5);max-width:800px;padding:20px}@media (max-width:810px){.alp-card{margin-left:10px!important;margin-right:10px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67d435e3","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Card.vue
// module id = 64
// module chunks = 0